/**
 * Health check router
 * @package @app/api
 */

import { z } from 'zod';
import { publicProcedure } from '../middleware/auth';

export const healthRouter = {
  /**
   * Simple health check
   */
  check: publicProcedure
    .output(
      z.object({
        status: z.literal('ok'),
        timestamp: z.string(),
      }),
    )
    .handler(async () => {
      return {
        status: 'ok' as const,
        timestamp: new Date().toISOString(),
      };
    }),

  /**
   * Detailed health check (includes DB connectivity)
   */
  detailed: publicProcedure
    .output(
      z.object({
        status: z.enum(['ok', 'degraded', 'error']),
        timestamp: z.string(),
        services: z.object({
          database: z.boolean(),
          auth: z.boolean(),
        }),
      }),
    )
    .handler(async () => {
      const { prisma } = await import('@app/db');

      let databaseOk = false;
      try {
        await prisma.$queryRaw`SELECT 1`;
        databaseOk = true;
      } catch {
        databaseOk = false;
      }

      return {
        status: databaseOk ? 'ok' : 'degraded',
        timestamp: new Date().toISOString(),
        services: {
          database: databaseOk,
          auth: true, // Better Auth is always available
        },
      };
    }),
};
